import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, onUnmounted, ref } from 'vue';
export default {
  __name: 'BackToTop',
  setup(__props) {
    const visible = ref(false);
    let frameId = null;
    const update = () => {
      frameId = null;
      visible.value = window.scrollY > 520;
    };
    const schedule = () => {
      if (frameId !== null) return;
      frameId = requestAnimationFrame(update);
    };
    const scrollToTop = () => {
      const reduced = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: 0,
        behavior: reduced ? 'auto' : 'smooth'
      });
    };
    onMounted(() => {
      update();
      window.addEventListener('scroll', schedule, {
        passive: true
      });
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', schedule);
      if (frameId !== null) cancelAnimationFrame(frameId);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Transition, {
        name: "to-top"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("button", {
          class: "to-top",
          type: "button",
          "aria-label": "回到页面顶部",
          onClick: scrollToTop
        }, _cache[0] || (_cache[0] = [_createElementVNode("span", {
          "aria-hidden": "true"
        }, "↑", -1)]), 512), [[_vShow, visible.value]])]),
        _: 1
      });
    };
  }
};